export const DEFAULT_HEADER = 'Are you sure you want to close?';
export const DEFAULT_CONTENT =
  'You have unsaved changes. If you click in Yes your changes will be lost.';
